export const GET_COMPANIES = 'company.GET_COMPANIES'
export const SET_COMPANIES = 'company.SET_COMPANIES'

export const GET_COMPANY = 'company.GET_COMPANY'
export const SET_COMPANY = 'company.GET_COMPANY'

export const getCompanies = (params, callback) => ({
  type: GET_COMPANIES,
  params,
  callback,
})

export const setCompanies = (data) => ({
  type: SET_COMPANIES,
  data
})

export const getCompany = (companyId, callback) => ({
  type: GET_COMPANY,
  companyId,
  callback,
})

export const setCompany = (data) => ({
  type: SET_COMPANY,
  data
})
